import React, { Component } from 'react';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import BasicTemplate from './BasicTemplate.js'


class Pending extends Component {

    constructor(props) {
        super(props);
        this.state = { pending: '' };
    }

    render() {
        return (
            <BasicTemplate>
                <h3><b>Gracias por tomarse el tiempo de llenar el formulario.</b></h3>
                <p>Luego de analizar su <b>Perfil Crediticio</b>, no hemos encontrado un Préstamo Online para ofrecerle </p>
                <p>Estamos analizando su <b>Perfil</b> Crediticio más detenidamente, para ver si contamos con alguna otra alternativa para ofrecerle.</p>
            </BasicTemplate>
        );
    }
}

Pending = TopScrolleable(Pending);

Pending = withAuthControl(Pending);

export default Pending;



/** WEBPACK FOOTER **
 ** ./src/components/Pending.js
 **/